<fieldset {disabled}>
  <slot />
</fieldset>

<script lang="ts">
  export let disabled = false
</script>
